import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { Router } from '@angular/router';
import { GeneralMethods } from '../globalClass/general-methods';
import { ModuloService } from '../parametricas/shared/modulo.service';
import { InfoUserService } from '../info-user/shared/info-user.service';
import { VariablesService } from '../globalService/variables.service';
import { MessageSweetAService } from '../shared/messages/message-sweet-a.service';
import { LoginService } from '../pages/login/shared/login.service';
declare var $: any;

@Component({
  selector: 'app-nav-bar',
  templateUrl: './nav-bar.component.html'
})
export class NavBarComponent implements OnInit {

  //Administración
  administracionMenu = false;
  usuariosMenu = false;
  auditoriaMenu = false;
  parametricasMenu = false;
  //----------------//
  //Configuración
  configuracionMenu = false;
  grupoEconomicoMenu = false;
  empresasMenu = false;
  rolesMenu = false;
  modulosMenu = false;
  //---------------//
  //WePAC'S
  pacsMenu = false;
  creacionProgramaYContratistaMenu = false;
  solicitudDePolizaYModificacionesMenu = false;
  facturacionMenu = false;
  controlCuposyCumulosMenu = false;
  controlDeGarantiasMenu = false;
  polizasGlobalMenu = false;
  solicitudConsultasTecnicasMenu = false;
  reportesConsultasReportesMenu = false;
  gestionSolicitudes = false;
  polizasEmitidasPorFueraDelProgramaMenu = false
  //--------------//
  //Siniestros
  siniestrosMenu = false;
  radicacionMenu = false;
  incumpliminetoMenu = false;
  consultaYReportesMenu = false;
  //------------------------//
  //Sarlaft
  sarlaftMenu = false;
  consultaModificacionSarlaftMenu = false;
  reporteSarlaftMenu = false;
  //-------------------//
  //Tablero de Control
  administracionComercialMenu = false;
  //------------------//
    //-------------------//
  //WeCumplimineto
  weCumplimientoMenu = false;
  weCumplimientoGenerarSolicitudMenu = false;
  weCumplimientoSolicitudesRecibidasMenu = false;
  weCumplimientoReportesMenu = false;
  weCumplimientoCuposCumulosMenu = false;
  weCumplimientoNegociacionAseguradoraMenu = false;
  viewContentWeCumplimiento = false;
  //------------------//
  
  //-----INACTIVITY-----//
  timeOutInactivity: any;
  timeOutTimeMaxSession: any;
  timeInactivity: any;
  inervalTimeOutMessage: any;
  timeWaringClose: number;
  timeMaxSession: number;
  //-------------------//

  isTraduction: boolean = false;

  userName = "";

  constructor(
    private router: Router,
    private _moduleService: ModuloService,
    private _userInfo: InfoUserService,
    public generalMethod: GeneralMethods,
    private _chdr: ChangeDetectorRef,
    private _variableService: VariablesService,
    private messageSweetService: MessageSweetAService,
    private loginService: LoginService
  ) {
    this._moduleService.sendModulesFn = this.setModule;
    this.setModule(this._moduleService.modules);
  }

  ngOnInit() {
    setTimeout(() => {
      this.loadInit();
    }, 400);
  }

  loadInit(){
    this._userInfo.getDataUser().then(r => {
      let dataUser = r;
      if (dataUser != null) {
        if (typeof (dataUser.modules) != 'undefined') {
          this.setModule(dataUser.modules);
        }
      }
      this.userName = dataUser?.name;
    });

    this._variableService.getVariables().then(() => {
      this.timeInactivity = this._variableService.data.inactividad.inactividadAplicacion;
      this.timeWaringClose = this._variableService.data.inactividad.tiempoMostrarMensaje;
      this.timeMaxSession = this._variableService.data.inactividad.cierreSesionMaxima;
      this.isTraduction = this._variableService.data.mostrarTraduccion;

      if (sessionStorage.getItem("jwt") != null && typeof sessionStorage.getItem("jwt") !== 'undefined') {
        this.initInactivity();
        this.maxSession();
      }
    });
  }

  initInactivity() {
    this.timeOutInactivity = setTimeout(() => { this.showMessageInactivity() }, this.timeInactivity);

    $(document).on('click keypress load mousedown', () => {
      this.resetTime(false);
    });
  }

  maxSession() {
    this.timeOutTimeMaxSession = setTimeout(() => { this.showMessageMaxActivity() }, this.timeMaxSession);
  }

  resetTime(flag: boolean) {
    clearTimeout(this.timeOutInactivity);
    this.timeOutInactivity = setTimeout(() => { this.showMessageInactivity() }, this.timeInactivity);
    this.timeWaringClose = this._variableService.data.inactividad.tiempoMostrarMensaje;

    if (flag) {
      clearInterval(this.inervalTimeOutMessage);
    }
  }

  showMessageMaxActivity() {
    this.logOut();
    this.messageSweetService.messageWaring("Advertencia!", "Su sesión ha llegago al tiempo de actividad máximo permitido. Si desea continuar, por favor ingrese nuevamente.");
  }

  showMessageInactivity() {
    this.messageSweetService.messageConfirmation("Advertencia!", "<p class='swal2-content'>Su sesión se cerrará en: </br> ¿Aún se encuentra en la aplicación? </p>", "warning",
      "Si", "No",
      (response) => {
        if (response == true) {
          this.resetTime(true);
        } else {
          this.logOut();
        }
      });

    this.inervalTimeOutMessage = setInterval(() => {
      this.timeWaringClose = (this.timeWaringClose - 1);

      $("#swal2-content").html(`<p class='swal2-content'>Su sesión se cerrará en: <strong>${this.timeWaringClose}</strong> </br> ¿Aún se encuentra en la aplicación? </p>`);

      if (this.timeWaringClose == 0) {
        this.messageSweetService.messageWaring("Advertencia!", "Su sesión fue cerrada por inactividad.");
        this.logOut();
      }
    }, 1000);
  }

  logOut() {
    $(document).off('click keypress load mousedown');

    clearInterval(this.inervalTimeOutMessage);
    clearTimeout(this.timeOutInactivity);
    clearTimeout(this.timeOutTimeMaxSession);
    this.inervalTimeOutMessage = null;
    this.timeOutInactivity = null;
    this.timeOutTimeMaxSession = null;

    this.loginService.logOut().then(() => {
      sessionStorage.removeItem('jwt');
      sessionStorage.removeItem("userInfo");
      sessionStorage.removeItem("typeRol");
      sessionStorage.clear();
      this._userInfo.remove();
      this.router.navigate(["login"]);
    });
    setTimeout(() => {
      document.querySelectorAll(".modal-backdrop").forEach(el => el.remove());
    }, 200);
  }

  getModule() {
    return this._moduleService.modules;
  }

  setModule = async (module: any[]) => {
    await this._moduleService.setModules(module);
    this.administracionMenu = this._moduleService.administracionMenu;
    this.usuariosMenu = this._moduleService.usuariosMenu;
    this.auditoriaMenu = this._moduleService.auditoriaMenu;
    this.parametricasMenu = this._moduleService.parametricasMenu;
    this.configuracionMenu = this._moduleService.configuracionMenu;
    this.grupoEconomicoMenu = this._moduleService.grupoEconomicoMenu;
    this.empresasMenu = this._moduleService.empresasMenu;
    this.rolesMenu = this._moduleService.rolesMenu;
    this.modulosMenu = this._moduleService.modulosMenu;
    this.pacsMenu = this._moduleService.pacsMenu;
    this.creacionProgramaYContratistaMenu = this._moduleService.creacionProgramaYContratistaMenu;
    this.solicitudDePolizaYModificacionesMenu = this._moduleService.solicitudDePolizaYModificacionesMenu;
    this.facturacionMenu = this._moduleService.facturacionMenu;
    this.gestionSolicitudes = this._moduleService.gestionSolicitudesMenu;
    this.polizasEmitidasPorFueraDelProgramaMenu = this._moduleService.polizasEmitidasPorFueraDelProgramaMenu;
    this.controlCuposyCumulosMenu = this._moduleService.controlCuposyCumulosMenu;
    this.controlDeGarantiasMenu = this._moduleService.controlDeGarantiasMenu;
    this.polizasGlobalMenu = this._moduleService.polizasGlobalMenu;
    this.solicitudConsultasTecnicasMenu = this._moduleService.solicitudConsultasTecnicasMenu;
    this.reportesConsultasReportesMenu = this._moduleService.reportesConsultasReportesMenu;
    this.siniestrosMenu = this._moduleService.siniestrosMenu;
    this.radicacionMenu = this._moduleService.radicacionMenu;
    this.incumpliminetoMenu = this._moduleService.incumpliminetoMenu;
    this.consultaYReportesMenu = this._moduleService.consultaYReportesMenu;
    this.sarlaftMenu = this._moduleService.sarlaftMenu;
    this.consultaModificacionSarlaftMenu = this._moduleService.consultaModificacionSarlaftMenu;
    this.reporteSarlaftMenu = this._moduleService.reporteSarlaftMenu;
    this.administracionComercialMenu = this._moduleService.administracionComercialMenu;
    this.weCumplimientoMenu = this._moduleService.weCumplimientoMenu;
    this.weCumplimientoGenerarSolicitudMenu = this._moduleService.weCumplimientoGenerarSolicitudMenu;
    this.weCumplimientoSolicitudesRecibidasMenu = this._moduleService.weCumplimientoSolicitudesRecibidasMenu;
    this.weCumplimientoReportesMenu = this._moduleService.weCumplimientoReportesMenu;
    this.weCumplimientoCuposCumulosMenu = this._moduleService.weCumplimientoCuposCumulosMenu;
    this.weCumplimientoNegociacionAseguradoraMenu = this._moduleService.weCumplimientoNegociacionAseguradoraMenu;
    this._chdr.detectChanges();
  }
}
